import React from 'react';

export function PayRow({
  label, value, sub, bold, valueColor, status,
}: {
  label: string;
  value: string;
  sub?: string;
  bold?: boolean;
  valueColor?: string;
  status?: 'paid' | 'pending';
}) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
      padding: '0.5rem 0', borderBottom: '1px solid rgba(255,255,255,0.08)', gap: '1rem',
    }}>
      <div>
        <span style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)', fontWeight: bold ? 600 : 400 }}>
          {label}
        </span>
        {sub && <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', marginTop: '0.125rem' }}>{sub}</p>}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
        {status === 'paid' && (
          <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--color-success)', background: 'var(--color-success-highlight)', padding: '0.0625rem 0.375rem', borderRadius: '0.25rem' }}>
            pagato
          </span>
        )}
        {status === 'pending' && (
          <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--color-text-faint)', background: 'rgba(255,255,255,0.06)', padding: '0.0625rem 0.375rem', borderRadius: '0.25rem' }}>
            in attesa
          </span>
        )}
        <span style={{ fontSize: 'var(--text-sm)', fontWeight: bold ? 700 : 500, color: valueColor ?? 'var(--color-text)' }}>
          {value}
        </span>
      </div>
    </div>
  );
}
